const RESIZE = '1300';
export default RESIZE;
